var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"embeded-google-map",staticStyle:{"border":"0"},attrs:{"title":"Google map","src":_vm.src,"loading":"lazy","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }